import {RIBBON_VHELP_CLUB_ID} from '#shared/constants';
import type {Gsoa_ProductCatalog_ProductDetail as ProductDetail} from '~/openapi';
import {Ribbon, type RibbonData} from '~/types/product';

export function gsoaPaginationParams(page: number, pageSize: number) {
	return computerToHumanIndexing(Math.floor(page / pageSize)) - 1;
}

export function extractProductRibbons(product: ProductDetail): RibbonData[] {
	return [
		// Add help ribbon based on customer club discounts
		// https://gitlab.com/apploud/globus-mujglobusweb/-/issues/2995
		{
			display: canShowHelpRibbon(product),
			type: Ribbon.vHelp,
		},
		...Object
			.entries(product.ribbon ?? {})
			.map(([type, data]): RibbonData => ({
				type: type as Ribbon,
				...data,
			})),
	].filter(({display}) => !!display);
}

export function canShowHelpRibbon(product: ProductDetail): boolean {
	return product.productInHouse?.customerClubDiscounts?.some((discount) => discount.customerClub === RIBBON_VHELP_CLUB_ID) ?? false;
}
